import {commonPromise} from '../../http'
import {
    CREATE_SINGLE_ORDER,
    CREATE_GROUP_ORDER,
    INVITE_GROUP,
    ORDER_CHECK,
    ORDER_INFO,
    GET_COUPON_LIST,
    ALL_ADDRESS,
    ADD_ADDRESS,
    UPDATE_ADDRESS,
    DEL_ADDRESS,
    INFO_ADDRESS,
    ADDR_CHOICE,
    QUERY_ORDER_GROUP_BY_GID,
    GET_ORDER_PATH,
    IS_VERIFICATION,
    QUERY_ORDER_ADDRESS,
    QUERY_COURSE_TRY_TO_SEE,
    CHECK_FOLLOW,
    CHECK_FOLLOWS
} from '../global'

export const createSingleOrder = (data) => commonPromise(data, CREATE_SINGLE_ORDER, 'post');// 创建单独购订单
export const createGroupOrder = (data) => commonPromise(data, CREATE_GROUP_ORDER, 'post');// 创建团购购订单
export const inviteGroupOrder = (data) => commonPromise(data, INVITE_GROUP);// 邀请参团
export const orderCheck = (data) => commonPromise(data, ORDER_CHECK);// 检查团购订单
export const getOrderInfo = (data) => commonPromise(data, ORDER_INFO);// 检查团购订单
export const getCouponList = (data) => commonPromise(data, GET_COUPON_LIST);// 获取优惠券列表

export const allAddress = (data) => commonPromise(data, ALL_ADDRESS)// 所有地址
export const addAddress = (data) => commonPromise(data, ADD_ADDRESS, 'post')// 添加地址
export const updateAddress = (data) => commonPromise(data, UPDATE_ADDRESS, 'post')// 修改地址
export const deleteAddress = (data) => commonPromise(data, DEL_ADDRESS)// 删除地址
export const infoAddress = (data) => commonPromise(data, INFO_ADDRESS)// 根据id查看地址
export const addrChoice = (data) => commonPromise(data, ADDR_CHOICE)// 选择地址，查询运费
export const getQueryOrder = (data) => commonPromise(data, QUERY_ORDER_GROUP_BY_GID)// 支付成功信息
export const getOrderPath = (data) => commonPromise(data, GET_ORDER_PATH)// 物流信息
export const isVerification = (data) => commonPromise(data, IS_VERIFICATION)// 判断订单是否是实物，是否开启IOS
export const queryOrder = (data) => commonPromise(data, QUERY_ORDER_ADDRESS)// 查询用户历史地址
export const courseTryToSee = (data) => commonPromise(data, QUERY_COURSE_TRY_TO_SEE)// 查询用户历史地址
export const checkFollow = (data) => commonPromise(data, CHECK_FOLLOW)// 检查用户是否关注公众号
export const checkFollowS = (data) => commonPromise(data, CHECK_FOLLOWS)// 检查用户是否关注公众号



// WEBPACK FOOTER //
// ./src/api/apiModules/paymentApi.js